import type { Article } from "@/providers/content/types";


export function calculateReadingTime(article: Article): number {
  // Remove markdown syntax (basic)
  const plainText = article.content
    .replace(/`[^`]*`/g, "")             // inline code
    .replace(/```[\s\S]*?```/g, "")      // code blocks
    .replace(/!\[.*?\]\(.*?\)/g, "")     // images
    .replace(/\[.*?\]\(.*?\)/g, "")      // links
    .replace(/[#>*_\-~`]+/g, "")         // markdown symbols
    .replace(/\s+/g, " ")                // extra whitespace
    .trim();

  const words = plainText.split(" ").length;
  const minutes = Math.ceil(words / 240);

  return minutes;
};
